export const CREATION_TIME_SECTION = {
  FIRST_SMS_TIME: "Initial SMS DT",
  CREATION_TIME: "Creation DT",
};

export const BOOKING_STATUS = {
  APPROVED: "APPROVED",
  PENDING_APPROVAL: "PENDING APPROVAL",
  REJECTED: "REJECTED",
};

export const CLINIC_TYPE_ICON_MAPPING = {
  rural: "fas fa-home",
  metro: "fas fa-city",
};

export const EMAIL_TEMPLATE_TYPE = {
  CLIENT: "Client",
  CLINIC: "Clinic",
  REFERRER: "Referrer",
  CASE_MANAGER: "Case Manager",
};

export const TABLE_NAME = {
  workflow: "workflow",
  history: "history",
};
